import { mapState, mapGetters } from 'vuex';
import moment from 'moment';

const deviceMixin = {
  computed: {
    ...mapState({
      showActionModal: (state) => state.deviceDetail.showActionModal,
      actionModalView: (state) => state.deviceDetail.actionModalView,
      loadingDeviceDetail: (state) => state.deviceDetail.loadingDeviceDetail,
      processingMigration: (state) => state.deviceDetail.processingMigration,
      currentUid: (state) => state.deviceDetail.currentUid,
      memberUids: (state) => state.deviceDetail.memberUids,
      hub: (state) => state.deviceDetail.hub,
      hvac: (state) => state.deviceDetail.hvac,
      hubStatus: (state) => state.deviceDetail.hubStatus || {},
      modalHeader: (state) => state.deviceDetail.modalHeader,
      firmware: (state) => state.deviceDetail.firmware,
      customer: (state) => state.deviceDetail.customer,
      graphData: (state) => state.deviceDetail.graphData,
      deviceStatusTableHeaders: (state) => state.deviceDetail.deviceStatusTableHeaders,
      lastSensorReadings: (state) => state.deviceDetail.lastSensorReadings,
      timezone: (state) => state.deviceDetail.timezone,
      timezoneFormat: (state) => state.deviceDetail.timezoneFormat,
      sensors: (state) => state.deviceDetail.sensors,
      graphToggleState: (state) => state.deviceDetail.graphToggleState,
      activeTab: (state) => state.deviceDetail.activeTab,
      selectedJSON: (state) => state.deviceDetail.selectedJSON,
      startTime: (state) => state.deviceDetail.startTime,
      endTime: (state) => state.deviceDetail.endTime,
      commands: (state) => state.device.commands,
      deviceConfig: (state) => state.deviceDetail.deviceConfig || {},
      showDateError: (state) => state.deviceDetail.showDateError,
      allSupplySerialCycles: (state) => state.deviceDetail.allSupplySerialCycles,
      selectedSupplySerial: (state) => state.deviceDetail.selectedSupplySerial,
      loadingCycleChart: (state) => state.deviceDetail.loadingCycleChart,
      activeSingleTZone: (state) => state.customerDetail.systemFilterRef.singleTZone,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'cycleChartData',
      'deviceStatusTableData',
      'pendingCommandsTableData',
      'completedCommandsTableData',
    ]),
    partnerView() {
      const { path } = this.$route;
      return path.includes('member');
    },
  },
  watch: {
    activeSingleTZone(newVal) {
      if (newVal) {
        this.fetchData(newVal);
      }
    },
  },
  methods: {
    setupDeviceDetail(uId, replace) {
      uId = uId.replace(/^\s+|\s+$/gm, '');
      if (replace && this.$route.params.uId !== uId) {
        this.$router.replace(`/device/${uId}`);
      }
      const tab = this.$route.query.activeTab;
      if (tab === 'chart') {
        this.$store.dispatch('changeDeviceDetailValue', {
          key: 'activeTab',
          value: tab,
        });
      }
      const validUID = uId.substring(0, 20);
      this.$store.dispatch('setDetailDevice', {
        uid: validUID,
      });
    },
    async fetchData() {
      let queryUid;
      if (this.$route.params.uId) {
        queryUid = this.$route.params.uId;
      } else if (this.activeSingleTZone) {
        queryUid = this.activeSingleTZone.split('-')[0];
      }
      if (queryUid) {
        await this.$store.dispatch('getCyclePayload', {
          startTime: this.$route.query.startTime,
          endTime: this.$route.query.endTime,
          uid: queryUid,
          selectedSupply: this.partnerView ? this.activeSingleTZone : null,
        });
      }
    },
    toggleActionModal(show, view, item, modalHeader) {
      if (!show) {
        this.$store.dispatch('changeDeviceDetailValue', {
          key: 'showActionModal',
          value: false,
        });
      } else {
        this.$store.dispatch('changeDeviceDetailValue', {
          key: 'actionModalView',
          value: view,
        });
        this.$store.dispatch('changeDeviceDetailValue', {
          key: 'showActionModal',
          value: show,
        });
        this.$store.dispatch('changeDeviceDetailValue', {
          key: 'modalHeader',
          value: modalHeader,
        });
        this.$store.dispatch('changeDeviceDetailValue', {
          key: 'selectedJSON',
          value: item,
        });
      }
    },
    changeTab(tab) {
      const isQueryExist = this.$route.query.activeTab;
      if (isQueryExist) {
        this.$router.replace(`/device/${this.currentUid}`);
      }
      if (tab === 'command') {
        this.$store.dispatch('getDeviceCommands');
      }
      this.$store.dispatch('changeDeviceDetailValue', {
        key: 'toggleMode',
        value: true,
      });
      this.$store.dispatch('changeDeviceDetailValue', {
        key: 'activeTab',
        value: tab,
      });
    },
    changeDeviceValue(field, value) {
      this.$store.dispatch('changeDeviceValue', {
        field,
        value,
      });
    },
    setTableFilter(device, field, value) {
      this.$store.dispatch('changeDeviceValue', {
        field: 'selectedFilter',
        value: {
          device,
          field,
          value,
        },
      });
    },
    changePartner(corpId) {
      const newCorpId = Number(corpId);
      this.$store.dispatch('changeDeviceValue', {
        field: 'selectedCorp',
        value: newCorpId,
      });
      this.$store.dispatch('getAllDevices', { corpId });
    },
    calculatePercent(value, total) {
      if (value && total) {
        return `${Math.round((value / total) * 100)}%`;
      }
      return '0%';
    },
    getMarkerColor(v) {
      let markerColor;
      const key = Number(v);
      if (key === 0) {
        markerColor = '#F83356';
      } else if (key === 1) {
        markerColor = '#4CD6CF';
      } else if (key === 2) {
        markerColor = '#6d6e71';
      } else if (key === 3) {
        markerColor = '#0272ff';
      } else if (key === 4) {
        markerColor = '#e8420f';
      } else if (key === 5) {
        markerColor = '#f3837d';
      } else if (key === 6) {
        markerColor = '#3bdbcc';
      } else if (key === 7) {
        markerColor = '#eb008b';
      } else if (key === 8) {
        markerColor = '#FFCD66';
      }
      return markerColor;
    },
    formatTimezone(v, partnerView) {
      let value = '-';
      if (v) {
        let hourOption = 'h:mm:ss A';
        if (partnerView) {
          return moment(v).format(`ddd, MM-DD-YYYY, ${hourOption}`);
        }
        if (this.timezoneFormat === 24) {
          hourOption = 'H:mm:ss';
        }
        if (this.timezone === 'utc') {
          value = moment.utc(v).format(`ddd, MM-DD-YYYY, ${hourOption}`);
        } else if (this.timezone === 'local') {
          value = moment(v).format(`ddd, MM-DD-YYYY, ${hourOption}`);
        } else if (this.timezone === 'member' && this.hub.tzOffset) {
          value = moment(v).utcOffset(this.hub.tzOffset).format(`ddd, MM-DD-YYYY, ${hourOption}`);
        }
      }
      return value;
    },
    deviceType(type) {
      if (type === 'A2TempPressure') {
        return 'Filter Sensor';
      }
      if (type === 'TempPressure') {
        return 'Filter Sensor';
      }
      if (type === 'A2WaterLeak') {
        return 'Water Sensor';
      }
      if (type === 'WaterLeak') {
        return 'Water Sensor';
      }
      if (type === 'A2TempHumidity') {
        return 'Comfort Sensor';
      }
      if (type === 'Temp') {
        return 'Comfort Sensor';
      }
      return 'Hub';
    },
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment.utc(value).format('M/D/YY');
      }
      return '--';
    },
    date(date) {
      if (date) {
        return moment(date).format('M/DD/YY h:mmA');
      }
      return '--';
    },
    deviceLabel(type) {
      if (type === 'Supply Air') {
        return 'Comfort Sensor';
      }

      if (type === 'Room Ambient') {
        return 'Filter Sensor';
      }

      if (type === 'Attic') {
        return 'Water Sensor';
      }

      if (type === 'Room') {
        return 'Room Sensor';
      }

      return 'Hub';
    },
    percent(percent) {
      if (percent === null) {
        return '--';
      }
      const number = Math.floor(percent * 100 * 100) / 100;
      return `${number}%`;
    },
  },
};

export default deviceMixin;
